import React from "react";
import {
  Box,
  Logo,
  IconManager,
  subscriptionsLogoPack,
  Text,
  Button,
} from "@deseretbook/react-ui";
import PropTypes from "prop-types";

IconManager.register(subscriptionsLogoPack);
const PromoContent = ({ content }) => {
  // Used when user is a BookshelfPlus member and not a DeseretVideo Member
  // Also used when the product contatins a variant that has "Movie Format" in the options_text
  const showVideoPromo = () => {
    return (
      <React.Fragment>
        <Box paddingBottom={0.5} justifyContent="center">
          <Box maxWidth={6}>
            <Logo name="deseretVideo" />
          </Box>
        </Box>
        <Text alignment="center" display="block">
          Stream hundreds of hours of movies, courses, talks, and lifestyle
          videos
        </Text>
        <Box paddingTop={1} justifyContent="center">
          <Button
            as="a"
            color="video"
            type="button"
            href="/subscriptions/video"
          >
            Sign Up Now
          </Button>
        </Box>
      </React.Fragment>
    );
  };
  // Used when user is a DeseretVideo Member and not a BookshelfPlus member.
  const showPlusPromo = () => {
    return (
      <React.Fragment>
        <Box paddingBottom={0.5} justifyContent="center">
          <Box maxWidth={6}>
            <Logo name="plus" />
          </Box>
        </Box>
        <Text alignment="center" display="block">
          Unlimited Audiobooks &amp; Talks + over 2,500 eBooks
        </Text>
        <Box paddingTop={1} justifyContent="center">
          <Button as="a" color="plus" type="button" href="/bookshelf-plus">
            Sign Up Now
          </Button>
        </Box>
      </React.Fragment>
    );
  };
  // Used to hide promo content
  const showDefault = () => {
    return (
      // hidden
      <React.Fragment></React.Fragment>
    );
  };
  // content comes from promo_helper.rb under promo_options
  switch (content) {
    case "videoPlus":
      return showVideoPromo();
    case "bookshelfPlus":
      return showPlusPromo();
    default:
      return showDefault;
  }
};

PromoContent.propTypes = {
  content: PropTypes.string,
};

PromoContent.defaultProps = {
  content: "default",
};

export default PromoContent;
